var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.virtualList.elements),function(e){return _c('div',{key:_vm.getKey(e),ref:_vm.getKey(e),refInFor:true,attrs:{"id":_vm.getKey(e)}},[_vm._t("entry",function(){return [_vm._v(" "+_vm._s(e)+" ")]},{"entry":e})],2)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }